import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Grid, Button, Snackbar, Typography } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { useLocation } from "react-router-dom";
import PrintComponent from "../../PrintComponent";
import AcknowledgementReceiptDownload from "./download";
import TextArea from "../../../atoms/Textarea";
import moment from "moment";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import ContactDetailField from "../../../molecules/ContactDetailField";
import DescriptionIcon from "@mui/icons-material/Description";
import ReceiptIcon from "@mui/icons-material/Receipt";

const AcknowledgementReceiptClientSide = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");
  const [surveyData, setSurveyData] = useState([]);


  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (data) => {
    setIsLoading(true);

    let media = [];
    if (formContent?.clientSign != "") media[0] = formContent?.clientSign;

    const body = {
      formContentId: formContentId,
      content: data,
      mediaKeys: media,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        setSnackbarMessage("Signature has been added successfully!");
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);


  return (
    <>
      {isValid ? (
         <PremiumPublicLayout
            title="Acknowledgement Receipt"
            hideBackButton={true}
            actions={
                <div className="d-flex gap-3">
                    {!isEdit && (
                         <Button
                            variant="contained"
                            onClick={() => {
                                if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                      setIsLoading(true);
                                var tempTitle = document.title;
                                document.title = `Acknowledgement Receipt-${
                                formContent?.clientName
                                }-${moment(new Date()).format("DD.MM.YYYY")}`;

                                window.print();
                                document.title = tempTitle;
                                setIsLoading(false);
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--text-main)",
                                boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                                '&:hover': { backgroundColor: '#000' }
                            }}
                            startIcon={<DescriptionIcon />}
                        >
                            Save as PDF
                        </Button>
                    )}
                </div>
            }
        >
            <SectionHeader title="Receipt Details" icon={<ReceiptIcon />} />
            <PremiumCard sx={{ marginBottom: "32px" }}>
                <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                        <ContactDetailField
                            label="Date"
                            isEdit={isEdit}
                            type="date"
                            minWidth={"100%"}
                            value={formContent?.date}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.date = e.target.value;
                                setFormContent(values);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                         <ContactDetailField
                            label="Received From"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.receivedFrom}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.receivedFrom = e.target.value;
                                setFormContent(values);
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12}>
                        <ContactDetailField
                            label="Address"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.address}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.address = e.target.value;
                                setFormContent(values);
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12}>
                        <div className="mb-2">
                             <label className="fw-bold mb-1 d-block">On Account of</label>
                             {isEdit ? (
                                <TextArea
                                    value={formContent?.onAccountOf}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.onAccountOf = e.target.value;
                                        setFormContent(values);
                                    }}
                                    rows={3}
                                />
                             ) : (
                                <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                    {formContent?.onAccountOf || "-"}
                                </Typography>
                             )}
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mb: 3 }}>
                     <Grid item xs={12}>
                        <ContactDetailField
                            label="Amount"
                            isEdit={isEdit}
                            type="number"
                            minWidth={"100%"}
                            value={formContent?.amount}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.amount = e.target.value;
                                setFormContent(values);
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                        <ContactDetailField
                            label="Cash/Cheque #"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.chequeNo}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.chequeNo = e.target.value;
                                setFormContent(values);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ContactDetailField
                            label="Drawn on Bank"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.drawnOnBank}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.drawnOnBank = e.target.value;
                                setFormContent(values);
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mb: 3 }}>
                     <Grid item xs={12}>
                        <ContactDetailField
                            label="In words"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.inWords}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.inWords = e.target.value;
                                setFormContent(values);
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mb: 3 }}>
                     <Grid item xs={12}>
                        <div className="mb-2">
                             <label className="fw-bold mb-1 d-block">Received By</label>
                             {isEdit ? (
                                <TextArea
                                    value={formContent?.receivedBy}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.receivedBy = e.target.value;
                                        setFormContent(values);
                                    }}
                                    rows={2}
                                />
                             ) : (
                                <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                    {formContent?.receivedBy || "-"}
                                </Typography>
                             )}
                        </div>
                    </Grid>
                </Grid>
            </PremiumCard>
         </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <PrintComponent>
        <AcknowledgementReceiptDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* /snackbar */}
    </>
  );
};

export default AcknowledgementReceiptClientSide;
